import { Box, Typography } from '@mui/material'
import styles from '../AttachmentImageGallery.module.scss'

export function AttachmentImageGalleryFooter({ items, activeIndex, setActiveIndex, setZoom, thumbRefs, safeLen }) {
  return (
    <footer className={styles.footer}>
      <Typography component="div" className={styles.footerLabel}>
        Images in this message ({safeLen})
      </Typography>
      <Box className={styles.thumbStrip}>
        {items.map((item, idx) => (
          <button
            key={item.id}
            type="button"
            ref={(el) => {
              thumbRefs.current[idx] = el
            }}
            className={`${styles.thumbBtn}${idx === activeIndex ? ` ${styles.thumbBtnActive}` : ''}`}
            onClick={() => {
              setZoom(1)
              setActiveIndex(idx)
            }}
            aria-label={`View ${item.file?.name ?? 'image'} ${idx + 1} of ${safeLen}`}
            aria-current={idx === activeIndex ? 'true' : undefined}
          >
            {item.previewUrl ? <img src={item.previewUrl} alt="" className={styles.thumbImg} /> : null}
          </button>
        ))}
      </Box>
    </footer>
  )
}
